
// const ScrollToTop = () => {
//     window.scrollTo({
//         top: 0,
//         behavior: 'instant'
//     });
//     return null
// }

// export default ScrollToTop

import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "instant" // instant scroll
    });
  }, [pathname]); // runs ONLY when the route changes

  return null;
}
